import { jsx as t, jsxs as l, Fragment as L } from "react/jsx-runtime";
import { formatAddress as A, sortAsc as I } from "@strata/helper-functions";
import "./main.scss";
import { Tooltip as h } from "@strata/react-tooltip";
import C from "classnames";
import { Icon as O } from "@blueprintjs/core";
import { IconNames as v } from "@blueprintjs/icons";
import { formatDollarAmount as P } from "@strata/react-dollar-amount";
import b from "@strata/strata-ui/assets/illustrations/copay.svg?react";
const u = ({ label: e = void 0 }) => /* @__PURE__ */ t("div", { className: "sds_label sds_label--detail font-semi-bold--uppercase", children: e }), _ = ({ value: e = void 0 }) => /* @__PURE__ */ t("div", { className: "sds_value sds_value--detail", children: e ?? "--" }), W = ({
  label: e = "Address",
  address1: i = void 0,
  address2: s = void 0,
  city: o = void 0,
  state: a = void 0,
  zip: n = void 0,
  className: d = void 0,
  style: m = void 0
}) => /* @__PURE__ */ l("div", { className: d, style: m, children: [
  /* @__PURE__ */ t(u, { label: e }),
  i && /* @__PURE__ */ t(_, { value: i }),
  s && /* @__PURE__ */ t(_, { value: s }),
  /* @__PURE__ */ t(_, { value: A(o, a, n) })
] }), E = ({ label: e = void 0, showLabelTooltip: i = !0 }) => /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
  h,
  {
    className: "sds_label sds_label--header font-semi-bold--uppercase",
    content: i ? e : void 0,
    hoverOpenDelay: 500,
    children: e
  }
) }), f = ({ value: e = void 0 }) => /* @__PURE__ */ t(h, { className: "sds_value sds_value--header", content: e, hoverOpenDelay: 500, children: e ?? "--" }), Y = ({
  label: e = "Address",
  address1: i = void 0,
  address2: s = void 0,
  city: o = void 0,
  state: a = void 0,
  zip: n = void 0,
  className: d = void 0,
  style: m = void 0
}) => /* @__PURE__ */ l("div", { className: d, style: m, children: [
  /* @__PURE__ */ t(E, { label: e }),
  i && /* @__PURE__ */ t(f, { value: i }),
  s && /* @__PURE__ */ t(f, { value: s }),
  /* @__PURE__ */ t(f, { value: A(o, a, n) })
] }), $ = ({
  label: e,
  values: i = [],
  className: s = void 0,
  style: o = void 0
}) => /* @__PURE__ */ l("div", { className: s, style: o, children: [
  /* @__PURE__ */ t(u, { label: e }),
  (i == null ? void 0 : i.length) > 0 ? i == null ? void 0 : i.map((a, n) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ t("div", { className: "sds_detail-list__item", children: /* @__PURE__ */ t(_, { value: a }) }, n)
  )) : /* @__PURE__ */ t(_, {})
] }), z = ({
  label: e,
  value: i,
  className: s = void 0,
  style: o = void 0
}) => /* @__PURE__ */ l("div", { className: s, style: o, children: [
  /* @__PURE__ */ t(u, { label: e }),
  /* @__PURE__ */ t(_, { value: i })
] }), y = ({ label: e = void 0 }) => /* @__PURE__ */ t("div", { className: "sds_label sds_label--form-title", children: e }), B = ({
  label: e,
  value: i = void 0,
  className: s = void 0,
  style: o = void 0
}) => /* @__PURE__ */ l("div", { className: s, style: o, children: [
  /* @__PURE__ */ t(y, { label: e }),
  /* @__PURE__ */ t("div", { className: "sds_value sds_value--form-title", children: i })
] }), G = ({
  label: e,
  showLabelTooltip: i,
  value: s,
  className: o = void 0,
  style: a = void 0
}) => /* @__PURE__ */ l("div", { className: o, style: a, children: [
  /* @__PURE__ */ t(E, { label: e, showLabelTooltip: i }),
  /* @__PURE__ */ t(f, { value: s })
] }), r = {
  NEW_START: "new_start",
  TRANSITION_OF_CARE: "transition_of_care",
  REFERRAL_PRODUCT: "referral_product",
  /** Not a strat rule, but used for icon */
  INCENTIVE_TOTAL: "incentive_total",
  COPAY: "copay"
}, p = {
  [r.NEW_START]: {
    text: "New start",
    iconName: v.NEW_PRESCRIPTION
  },
  [r.TRANSITION_OF_CARE]: {
    text: "Transition of care documentation required",
    iconName: v.EXCHANGE
  },
  [r.REFERRAL_PRODUCT]: {
    text: "Clinical documentation required",
    iconName: v.CLIPBOARD
  },
  [r.INCENTIVE_TOTAL]: {
    text: void 0,
    iconName: v.DOLLAR
  },
  [r.COPAY]: {
    text: "Copay assistance available",
    iconName: /* @__PURE__ */ t(
      b,
      {
        style: {
          width: "16px",
          height: "16px"
        }
      }
    )
  }
}, c = ({ value: e, iconOnly: i = !1 }) => {
  var a, n;
  const s = /* @__PURE__ */ t(
    O,
    {
      icon: (a = p[e.stratRule]) == null ? void 0 : a.iconName,
      size: 14,
      title: (n = p[e.stratRule]) == null ? void 0 : n.text
    }
  ), o = (d) => {
    var m, T, N;
    return e.stratRule === r.INCENTIVE_TOTAL ? `${P(
      e.incentiveTotal,
      !0,
      !0
    )} incentive for successfully fulfilling requirements for high-touch, quality care` : e.stratRule === r.REFERRAL_PRODUCT && d ? /* @__PURE__ */ l(L, { children: [
      /* @__PURE__ */ t("span", { children: `${(m = p[e.stratRule]) == null ? void 0 : m.text}:` }),
      /* @__PURE__ */ t("ul", { className: "sds_patient-info__tooltip-list", children: (T = e.names) == null ? void 0 : T.map((R) => /* @__PURE__ */ t("li", { children: R }, R)) })
    ] }) : (N = p[e.stratRule]) == null ? void 0 : N.text;
  };
  return /* @__PURE__ */ l("div", { className: "sds_patient-info", children: [
    /* @__PURE__ */ t("div", { className: "sds_patient-info__icon", children: i ? /* @__PURE__ */ t(h, { content: o(!0), children: s }) : s }),
    !i && /* @__PURE__ */ t("div", { className: "sds_patient-info__text", children: o(!1) })
  ] });
};
c.Types = r;
const x = ({ values: e, incentiveTotal: i }) => {
  const s = [], o = [];
  return (e ?? []).forEach((a) => {
    Object.values(c.Types).includes(
      a.strat_rule_name
    ) && (a.strat_rule_name === c.Types.REFERRAL_PRODUCT ? o.push(a.value_case_name) : s.push({
      stratRule: a.strat_rule_name,
      incentiveTotal: void 0,
      names: void 0
    }));
  }), o.length > 0 && (o.sort(I), s.unshift({
    stratRule: c.Types.REFERRAL_PRODUCT,
    names: o,
    incentiveTotal: void 0
  })), i && s.unshift({
    stratRule: c.Types.INCENTIVE_TOTAL,
    incentiveTotal: i,
    names: void 0
  }), s;
}, D = ({
  label: e,
  values: i = void 0,
  incentiveTotal: s = void 0,
  iconsOnly: o = !1,
  className: a = void 0,
  style: n = void 0
}) => (i ?? []).length > 0 ? /* @__PURE__ */ l("div", { className: a, style: n, children: [
  e && /* @__PURE__ */ t(u, { label: e }),
  /* @__PURE__ */ t(
    "div",
    {
      className: C("sds_patient-info-list", {
        "sds_patient-info-list--icons-only": o
      }),
      children: x({
        values: i,
        incentiveTotal: s
      }).map((d) => /* @__PURE__ */ t("div", { className: "sds_patient-info-list__item", children: /* @__PURE__ */ t(c, { value: d, iconOnly: o }) }, d.stratRule))
    }
  )
] }) : null;
D.Types = c.Types;
export {
  W as AddressDetailLabelValue,
  Y as AddressHeaderLabelValue,
  u as DetailLabel,
  $ as DetailLabelList,
  z as DetailLabelValuePair,
  _ as DetailValue,
  y as FormTitleLabel,
  B as FormTitleLabelValuePair,
  E as HeaderLabel,
  G as HeaderLabelValuePair,
  D as PatientInfoList
};
//# sourceMappingURL=index.js.map
